import { useCallback } from "react";
import { createTrackingUtils } from "..";
import useProfiler from "hooks/useProfiler";

const util = createTrackingUtils({
  name: "flights_web_aa_responsive_modal",
  defaultStage: 1,
  stages: {
    mount: 1,
    show: 2,
    accept: 3,
    direct: 4,
    meta: 5,
    solo: 6,
    nonsolo: 7,
    us: 8,
    nonus: 9
  },
  goals: {
    close: 1,
    showAgain: 2
  }
});

export default function useFlightsWebAAResponsiveModal() {
  const { isDirect, isSolo, isAmerican } = useProfiler();
  const trackStages = useCallback(() => {
    util.stages.accept(); // 3
    if (isDirect()) util.stages.direct(); // 4
    if (!isDirect()) util.stages.meta(); // 5
    if (isSolo()) util.stages.solo(); // 6
    if (!isSolo()) util.stages.nonsolo(); // 7
    if (isAmerican()) util.stages.us(); // 8
    if (!isAmerican()) util.stages.nonus(); // 9
  }, [isDirect, isSolo, isAmerican]);

  const onRender = useCallback(() => {
    util.stages.show(); // 2
  }, []);

  const onAccept = useCallback(() => {
    trackStages();
  }, [trackStages]);

  const onMount = useCallback(() => {
    util.stages.mount(); // 1
  }, []);

  return { onAccept, onRender, onMount };
}
